import { QueryClient, QueryClientProvider } from 'react-query';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import App from './App';
import i18n from './i18n';
import './index.css';

const options = {
    init: {
        distributed_tracing: {
            enabled: true
        },
        privacy:{cookies_enabled:true},
        ajax:{deny_list:["bam.nr-data.net"]}
    },
    info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
        applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
        sa:1
    },
    loader_config: {
        accountId: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
        trustKey: process.env.REACT_APP_NEW_RELIC_TRUST_KEY,
        agentID:  process.env.REACT_APP_NEW_RELIC_AGENT_ID,
        licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
        applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID
    }
};

new BrowserAgent(options);

const root = ReactDOM.createRoot(document.getElementById('root')!);
const queryClient = new QueryClient();

root.render(
    <BrowserRouter>
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </I18nextProvider>
    </BrowserRouter>
);
